<template>
  <div id="app">
    <a class="skip-link" href="#main-content">Skip to content</a>
    <AppHeader />
    <main id="main-content">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  components: { AppHeader, AppFooter }
};
</script>

<style>
:root {
  --ink: #171713;
  --paper: #eee9dc;
  --paper-light: #f8f4e9;
  --blue: #2449ff;
  --red: #ef4e2c;
  --yellow: #f0d83f;
  --green: #27684a;
  --line: 2px solid var(--ink);
  --page: min(1440px, calc(100vw - 48px));
}

* { box-sizing: border-box; }

html {
  scroll-behavior: smooth;
  background: var(--ink);
}

body {
  margin: 0;
  min-width: 320px;
  background: radial-gradient(rgba(23, 23, 19, 0.055) 0.7px, transparent 0.7px), var(--paper);
  background-size: 5px 5px;
  color: var(--ink);
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.45;
}

button, a { font: inherit; }
a { color: inherit; }

button:focus-visible,
a:focus-visible {
  outline: 3px solid var(--blue);
  outline-offset: 3px;
}

::selection { background: var(--yellow); color: var(--ink); }
#app { min-height: 100vh; overflow: hidden; }
#main-content { display: block; }

.skip-link {
  position: fixed;
  z-index: 999;
  top: 10px;
  left: 10px;
  padding: 10px 14px;
  border: var(--line);
  background: var(--yellow);
  transform: translateY(-160%);
  transition: transform 150ms ease;
}

.skip-link:focus { transform: translateY(0); }

@media (max-width: 700px) {
  :root { --page: calc(100vw - 24px); }
}

@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
